import styled from '@emotion/styled';
import { themeGet } from '@styled-system/theme-get';

export const MaxWidthContent = styled.div`
  > :first-of-type {
    margin-top: 0;
  }

  ${themeGet('mediaQueries.0')} {
    max-width: 66.66%;
  }
`;
